import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableList } from 'seagull';
import styles from './BillTableItem.module.scss';
export default function BillTableItem(props) {
    const { columnDefs, headerItems, rowItems, footer, headerTestId, actionColumn } = props;
    return /*#__PURE__*/ _jsx(TableList.Provider, {
        columnDefs: columnDefs,
        variant: "minimal",
        hasActionColumn: true,
        justifyBetween: true,
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.root,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.innerContainer,
                children: [
                    /*#__PURE__*/ _jsx(TableList.Header, {
                        className: styles.tableHeader,
                        items: headerItems,
                        testId: headerTestId,
                        bgColor: "darkGray"
                    }),
                    /*#__PURE__*/ _jsx(TableList.Row, {
                        disableShadow: true,
                        disableMarginBottom: true,
                        items: rowItems,
                        actionColumn: actionColumn
                    }),
                    footer
                ]
            })
        })
    });
}
